import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CleanUpStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-cleanupstatus',
  templateUrl: './cleanupstatus.component.html',
  styleUrls: ['./cleanupstatus.component.scss']
})
export class CleanUpStatusComponent implements OnChanges {


  cleanupstatusForm: FormGroup;
  cleanupstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() cleanupstatuss: CleanUpStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() cleanupstatus = new EventEmitter<CleanUpStatusDto[]>()
  @Output() deleteCleanUpStatusEvent = new EventEmitter<any>()

    selectedCleanUpStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createCleanUpStatusForm();
    }

    createCleanUpStatusForm() {
      this.cleanupstatusForm = this.fb.group({
        CleanUpStatusName: ['', Validators.required],
        id: null
        });
        this.cleanupstatusFormArray = this.fb.group({ CleanUpStatuss: this.fb.array([])
          });
        this.setCleanUpStatus();
    }

  // method to display cleanupstatuss
  setCleanUpStatus() {
    const control  = this.cleanupstatusFormArray.controls.CleanUpStatuss as FormArray;
    this.cleanupstatuss.forEach( e => {
      control.push(
        this.fb.group({
          CleanUpStatusName: e.CleanUpStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add CleanUpStatus
  addCleanUpStatus(value: CleanUpStatusDto) {
    const control  = this.cleanupstatusFormArray.controls.CleanUpStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            CleanUpStatusName: value.CleanUpStatusName,
            id: null
          })
       );
  }

  selectCleanUpStatus(value) {}

  // method to delete cleanupstatus from arrary list
  deleteCleanUpStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.cleanupstatusFormArray.controls.CleanUpStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.cleanupstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.cleanupstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: CleanUpStatusDto) {
    if(this.cleanupstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.cleanupstatusFormArray.get('CleanUpStatuss')['controls'][this.selectedIndex].patchValue({CleanUpStatusName: formValue.CleanUpStatusName});
    } else {
      this.addCleanUpStatus(formValue);
    }
    this.selectedIndex = null;
    this.cleanupstatusForm.reset()
  }

  onEdit(index, value: CleanUpStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.cleanupstatusForm.patchValue({CleanUpStatusName: value.CleanUpStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.cleanupstatusForm.reset();
  }

  onSubmit(formValue: CleanUpStatusDto[]) {
  this.cleanupstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteCleanUpStatusEvent.emit(this.filteredDelete);
  }
  }

}
